import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQAccordion = ({ items, testIdPrefix = "faq" }) => {
  return (
    <Accordion type="single" collapsible className="w-full" data-testid={`${testIdPrefix}-accordion`}>
      {items.map((item, i) => (
        <AccordionItem key={i} value={`item-${i}`} className="border-b border-gray-200">
          <AccordionTrigger className="text-left font-display font-bold text-base text-brand-black hover:text-brand-red hover:no-underline py-5" data-testid={`${testIdPrefix}-q-${i}`}>
            {item.q}
          </AccordionTrigger>
          <AccordionContent className="text-gray-600 leading-relaxed text-[15px] pb-5">
            {item.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
